module.exports = __webpack_public_path__ + "img/ibms_sold_out@2x.18719ee9.png";